(function () {
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (canHover && !reducedMotion) {
    initMagneticButtons();
  }

  if (!reducedMotion) {
    initHeroParallax();
  }

  if (canHover && !reducedMotion) {
    initHeroSpotlight();
  }

  function initMagneticButtons() {
    var buttons = document.querySelectorAll('.kawaii-button');
    var maxPull = 10;

    buttons.forEach(function (button) {
      button.addEventListener('mousemove', function (event) {
        var rect = button.getBoundingClientRect();
        var relX = event.clientX - rect.left - rect.width / 2;
        var relY = event.clientY - rect.top - rect.height / 2;
        var pullX = Math.max(Math.min(relX * 0.3, maxPull), -maxPull);
        var pullY = Math.max(Math.min(relY * 0.3, maxPull), -maxPull);
        button.style.setProperty('--mx', pullX + 'px');
        button.style.setProperty('--my', pullY + 'px');
      });

      button.addEventListener('mouseleave', function () {
        button.style.setProperty('--mx', '0px');
        button.style.setProperty('--my', '0px');
      });
    });
  }

  function initHeroParallax() {
    var media = document.querySelector('.hero-photo__media img');
    if (!media) return;

    var ticking = false;

    function update() {
      var scrolled = window.scrollY;
      media.style.transform = 'translateY(' + Math.min(scrolled * 0.12, 60) + 'px) scale(1.08)';
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
  }

  function initHeroSpotlight() {
    var media = document.querySelector('.hero-photo__media');
    if (!media) return;

    media.addEventListener('mousemove', function (event) {
      var rect = media.getBoundingClientRect();
      var x = ((event.clientX - rect.left) / rect.width) * 100;
      var y = ((event.clientY - rect.top) / rect.height) * 100;
      media.style.setProperty('--spot-x', x + '%');
      media.style.setProperty('--spot-y', y + '%');
      media.classList.add('is-spotlit');
    });

    media.addEventListener('mouseleave', function () {
      media.classList.remove('is-spotlit');
    });
  }
})();
